import Card from '@core/components/card/Card';

// import styles
import classes from './GuestUser.module.scss';

import { useRouter } from 'next/router';
import Link from 'next/link';

import UseModal from 'hooks/use-modal';
import Modal from '@core/components/Modal/Modal';
import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import Form from '@core/components/contentparser/sections/Newsletter/Form';

import cardImage from 'assets/logo/profile-card-image.png';
import newsLetterImage from 'assets/images/profile-newsletter-card.png';
// import icons
import FAQIcon from 'assets/icons/faq-icon.svg';
import OurMissionIcon from 'assets/icons/chart.svg?url';
import BookIcon from 'assets/icons/book-icon.svg';
import GiftIcon from 'assets/icons/gift-icon.svg';
import InstagramIcon from 'assets/icons/instagram-icon.svg';
import LinkedinIcon from 'assets/icons/linkedin-icon.svg';
import TiktokIcon from 'assets/icons/tiktok-icon.svg';

const GuestUser = ({ data }) => {
	const { show, showModal, destroyModal } = UseModal();
	const router = useRouter();

	let origin = '';
	if (router.isReady) {
		if (typeof window !== 'undefined') {
			origin = window.location.origin;
		}
	}

	return (
		<div className={`${classes['profile-container']} container py-5`}>
			<Card
				imageURL={cardImage.src}
				title={
					<>
						Start learning and growing your career with Pharmuni!
					</>
				}
				subTitle="Join us to"
				actions={[
					{
						label: 'Create account',
						callback: () => {
							router.replace('/get-started');
						}
					}
				]}
			/>
			<div className={`${classes['profile-menus']} d-flex`}>
				<div className={`${classes['item-icon']}`}>
					<Link href="/faq">
						<FAQIcon />
						<span className={`${classes['item-icon-label']}`}>FAQ</span>
					</Link>
				</div>
				<div className={`${classes['item-icon']}`}>
					<Link href="/redeem-gift-code">
						<GiftIcon />
						<span className={`${classes['item-icon-label']}`}>Reedem gift code</span>
					</Link>
				</div>
				<div className={`${classes['item-icon']}`}>
					<a href={`${origin}/our-mission/`} rel="noreferrer">
						<img src={OurMissionIcon} alt="our-mission-icon" />
						<span className={`${classes['item-icon-label']}`}>Our Mission</span>
					</a>
				</div>
				<div className={`${classes['item-icon']}`}>
					<a href={`${origin}/privacy-policy/`} rel="noreferrer">
						<BookIcon />
						<span className={`${classes['item-icon-label']}`}>Privacy policy</span>
					</a>
				</div>
			</div>
			<div className={`${classes['social-media-container']}`}>
				<span>Follow us on</span>
				<div className={`${classes['icons']}`}>
					<a href={data.social_media_urls.instagram_url} target="_blank" rel="noreferrer">
						<InstagramIcon />
					</a>
					<a href={data.social_media_urls.linkedin_url} target="_blank" rel="noreferrer">
						<LinkedinIcon />
					</a>
					{/* <a href={data.social_media_urls.tiktok_url} target="_blank" rel="noreferrer">
						<TiktokIcon />
					</a> */}
				</div>
			</div>
			<Card
				imageURL={newsLetterImage.src}
				title="don’t miss any big news"
				subTitle="Subscribe to our newsletter to"
				actions={[
					{
						label: 'Subscribe now',
						callback: showModal
					}
				]}
			/>
			<Modal show={show} title="Subscribe" closeHandler={destroyModal} type={MOBILE_SLIDE_UP}>
				<Form />
			</Modal>
		</div>
	);
};

export default GuestUser;
